import React, { Component } from 'react'
import { colors } from '../components/assets/shibui';

const STYLES = {
  textAlign: 'center',
  marginTop: '45px',
  color: colors.midnight.color
}

const COMMUNITY_LINK = 'https://join.slack.com/t/haiku-community/shared_invite/enQtMzc4OTg5NjcyNzIwLWJkYzJmY2FhZGI0NTE0N2JlNWFkOTM2NWYwZDRhNjNlNjgyNzA5ZDdlMmMxOWRjMDUzNzlhMWYzMzcxZTYzZjk'

class SlackCommunity extends Component {
  componentDidMount () {
    window.location.href = COMMUNITY_LINK
  }

  render() {
    return (
      <div style={STYLES}>
        <p>Redirecting to Haiku Community Slack...</p>
        <a href={COMMUNITY_LINK}><small>Click here if that doesn’t happen</small></a>
      </div>
    )
  }
}

export default SlackCommunity



// WEBPACK FOOTER //
// ./src/pages/slack-community.js